import { LitElement, html, css, unsafeCSS, property } from "lit-element";

import { reportsApi } from "../../api/reportsApi";

import defaultReportConfigStyles from "./default-report-config.scss";
import { UserModel } from "../../models/dashboard/UserModel";
import { DefaultReportConfigItemModel, DefaultReportConfigModel } from "../../models/report/DefaultReportConfigModel";
import DefaultReportConfigItem from "./default-report-config-item";
import ReportType from "../../enums/report-type";

export default class DefaultReportConfig extends LitElement {
    @property({ type: Object })
    defaultConfig: DefaultReportConfigModel;

    @property({ type: Object })
    defaultReportTypeConfigItem: DefaultReportConfigItemModel;

    private _container: HTMLElement;

    private _reportsUrl = "";
    private _mediaUrl = "";
    private _userId = "";

    private _reportType: number;
    private _users: UserModel[]
    private _reportsApi: reportsApi;
    constructor(
        container: HTMLElement,
        mediaUrl: string,
        reportsUrl: string,
        userId: string,
        users: UserModel[],
        reportType: number) {
        super();

        this._container = container;
        this._reportsUrl = reportsUrl;
        this._mediaUrl = mediaUrl;
        this._userId = userId;
        this._users = users.sort((a, b) => this.textSort(a, b, "userName"));;
        this._reportType = reportType;
        this._reportsApi = new reportsApi(this._reportsUrl, this._userId);
    }

    async firstUpdated() {

        this.showLoading(true, document.querySelector('#setup-loading-container'));

        this.defaultConfig = await this._reportsApi.GetDefaultReportConfigFromReports(this._userId);

        if (!this.defaultConfig || !this.defaultConfig.configItems) {
            this.defaultConfig = <DefaultReportConfigModel>{
                configItems: []
            };
        }
        else {
            let defaultReportTypeConfigItem = this.defaultConfig.configItems.find(x => x.reportType === this._reportType);

            if (defaultReportTypeConfigItem)
                this.defaultReportTypeConfigItem = defaultReportTypeConfigItem;
            else
                this.defaultReportTypeConfigItem = undefined;
        }

        this.showLoading(false, document.querySelector('#setup-loading-container'));
    }

    isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    textSort(a, b, property) {
        let returnValue = 0;

        if (a[property] < b[property])
            returnValue = -1;
        else
            returnValue = 1;

        return returnValue;
    }

    saveConfig = async () => {

        if (!this.defaultConfig || !this.defaultConfig.configItems)
            return;

        await this._reportsApi.PostDefaultReportConfigFromReports(this._userId, this.defaultConfig);
    }

    addConfigItem = () => {
        let newItem = <DefaultReportConfigItemModel>{
            reportId: '',
            reportType: null,
            templateId: '',
            userId: this._userId,
        }

        this.defaultConfig.configItems.push(newItem);
        this.requestUpdate();
    }

    showLoading(isLoading: boolean, container: HTMLElement) {
        if (isLoading) {
            container.innerHTML = "Loading...";
        }
        else {
            container.innerHTML = "";
        }
    }

    createRenderRoot() {
        return this;
    }

    render() {

        return [
            html`
            <style>
                ${css`${unsafeCSS(defaultReportConfigStyles)}`}                     
            </style>

            <div class="container">                

                ${(this.defaultConfig && this._reportType) ? (html`${new DefaultReportConfigItem(document.querySelector('#setup-loading-container'), this.defaultReportTypeConfigItem, this._mediaUrl, this._reportsUrl, this._userId, this._users, this._reportType, this.defaultConfig, this.requestUpdate)}`)
                    : html`${this.defaultConfig && this.defaultConfig.configItems.map((configItem) => html`${new DefaultReportConfigItem(document.querySelector('#setup-loading-container'), configItem, this._mediaUrl, this._reportsUrl, this._userId, this._users, 0, this.defaultConfig, this.requestUpdate)}`)}`}

                ${this._reportType ? html`` : html`
                <div class="row">
                    <div class="col"> <button class="btn btn-primary wide-element" @click=${this.addConfigItem}>Add Item</button> </div>
                    <div class="col"> <button class="btn btn-info wide-element" @click=${this.saveConfig}>Save Config</button> </div>
                </div>`}

<div class="row" >
    <div class="col loading-container" id = "setup-loading-container" > </div>`
        ];
    }
}

window.customElements.define('stratus-stats-default-report-config', DefaultReportConfig as any);